module.exports = require("./ca-IT.d.ts");